import {
  createContext,
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
  ReactNode,
} from 'react';
import PropTypes from 'prop-types';
import LOCALES from 'constants/locales';
import languagesObj, { enLang } from 'languages';
import { CountryCode } from 'libphonenumber-js/max';

export interface UserContextType {
  lastSelectedJob: any;
  setLastSelectedJob: Dispatch<SetStateAction<any>>;
  currentCountryCode: CountryCode | undefined;
  currentAppLocaleMessages: Record<string, string> | null;
  locale?: any;
  email?: string;
  setEmail: Dispatch<SetStateAction<string>>;
}

interface UserProviderProps {
  children?: ReactNode;
}

export const UserContext = createContext<UserContextType>({
  // user: null,
  // isSignedIn: false,
  lastSelectedJob: null,
  setLastSelectedJob: () => {},
  currentCountryCode: undefined,
  currentAppLocaleMessages: null,
  email: '',
  setEmail: () => {},
});

// ToDo: this context is in progress need to separate it into smaller contexts

const UserProvider = ({ children }: UserProviderProps): ReactNode => {
  const [lastSelectedJob, setLastSelectedJob] = useState(null);
  const [currentCountryCode, setCurrentCountryCode] = useState();
  const [email, setEmail] = useState('');
  const locale = 'en';

  const getSelectedLocaleMessages = useCallback(() => {
    const { messages: fallbackLocaleMessages } = enLang;
    const selectedLocaleMessages = Object.values(languagesObj)
    // @ts-ignore
      .find(({ locale: localeCode }) => localeCode === locale)?.messages;

    return locale === LOCALES.ENGLISH
      ? fallbackLocaleMessages
      : {
        ...fallbackLocaleMessages,
        ...selectedLocaleMessages,
      };
  }, [locale]);

  const [
    currentAppLocaleMessages,
    setCurrentAppLocaleMessages,
  ] = useState(() => getSelectedLocaleMessages());

  useEffect(() => {
    setCurrentAppLocaleMessages(getSelectedLocaleMessages());
  }, [getSelectedLocaleMessages]);

  const userContext = useMemo(() => ({
    locale,
    lastSelectedJob,
    currentCountryCode,
    setLastSelectedJob,
    currentAppLocaleMessages,
    email,
    setEmail,
  }), [
    currentAppLocaleMessages,
    currentCountryCode,
    lastSelectedJob,
    locale,
    setLastSelectedJob,
    email,
    setEmail,
  ]);

  return (
    <UserContext.Provider value={userContext}>
      {children}
    </UserContext.Provider>
  );
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UserProvider;
